module.exports = __webpack_public_path__ + "static/media/monop.2d85740d.png";